// The registered company address, one entry per display line. Shared by the
// footer and the contact page so the two can't drift apart.
export const COMPANY_ADDRESS_LINES = [
  'Kızılırmak Mah., Dumlupınar Bul.',
  'No: 3C-1, İç Kapı No: 160',
  'Çankaya / Ankara, Türkiye',
] as const;
